import { ProducedByDto } from "@/hooks/types";
import { AssetDto, BynderMetadataDto, ProducerDto } from "generated";

export type MetadataSection = {
  id: keyof AssetDto;
  title: string;
  transformation?: (
    value: string,
    producers?: ProducerDto[],
    producedBy?: ProducedByDto,
    metadata?: BynderMetadataDto,
    documentContentTypes?: Record<string, string>,
  ) => string;
  isOptionalField?: boolean;
  isConditionallyRequired?: (value: unknown, asset?: AssetDto) => boolean;
};

export enum ModalState {
  Hidden,
  Comments,
  AssetNames,
  SimilarAssets,
  Image,
}

export type MetadataEntry = {
  id: keyof AssetDto;
  title: string;
  showWarning?: boolean;
  hideValues?: boolean;
  entries: Record<string, number>;
};

export type CachedFileData = {
  id: number;
  filename: string;
  blobUrl: string;
  data: { type: string };
};
